import { Card } from "@/components/ui/card";

export default function CarDrAdvantage() {
  const rows = [
    ["Health Grade A", "0–2 historic DTCs · No active codes", "Up to 80% LTV"],
    ["Health Grade B", "Minor warning lights · Low repair estimate", "Up to 75% LTV"],
    ["Health Grade C", "Multiple DTCs · Material repair exposure", "Up to 65% LTV"],
    ["Health Grade D", "Major systems flagged · High repair estimate", "Up to 50% LTV"],
    ["Reject", "VIN mismatch / mileage tamper / unsafe", "Not financable"],
  ];
  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-16" data-testid="cardr-advantage-page">
      <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-3">CarDr advantage</div>
      <h1 className="text-4xl lg:text-5xl font-semibold text-slate-900">Diagnostics, not guesswork.</h1>
      <p className="mt-5 text-slate-600 max-w-3xl leading-relaxed">
        Used car lending is broken because lenders price every vehicle the same. CarDr's diagnostic platform reads the vehicle's own systems and gives Red Fort Capital a deterministic risk signal — before money moves.
      </p>
      <Card className="mt-10 overflow-hidden border-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <th className="text-left px-4 py-3">Grade</th>
              <th className="text-left px-4 py-3">What we see</th>
              <th className="text-left px-4 py-3">Lending policy</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-t border-slate-100">
                <td className="px-4 py-3 font-semibold text-slate-900 font-mono">{r[0]}</td>
                <td className="px-4 py-3 text-slate-700">{r[1]}</td>
                <td className="px-4 py-3 text-slate-700">{r[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { t: "DTC and warning lights", d: "Active, pending, historic and permanent diagnostic trouble codes flagged at module level." },
          { t: "Repair exposure", d: "Parts + labour estimate that we subtract from market value to compute lendable value." },
          { t: "Tamper detection", d: "Code reset attempts, mileage mismatch, and VIN integrity feed directly into underwriting flags." },
        ].map((b, i) => (
          <Card key={i} className="p-5 border-slate-200">
            <div className="font-semibold text-slate-900">{b.t}</div>
            <div className="text-sm text-slate-600 mt-2 leading-relaxed">{b.d}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
